import { colors } from "colors"
import React from "react"
import { View, Text, StyleSheet, Image } from "react-native"
import { typography } from "theme"

const EmptyState = () => {
  return (
    <View style={styles.container}>
      <Image
        source={require("../../assets/empty-icon.png")}
        resizeMode="contain"
        style={{ height: 50, width: 50, marginBottom: 10 }}
      />
      <Text style={styles.text}>There's nothing to show at the moment.</Text>
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    height: 80,
    justifyContent: "center",
    maxWidth: 800,
    width: "100%",
  },
  text: {
    color: colors.lightGrey,
    fontFamily: typography.primary.normal,
    fontSize: 13,

    marginBottom: 10,
    textAlign: "center",
    width: "100%",
  },
})

export default EmptyState
